<template>
    <div class="product-box">
        <div class="product-img">
            <img :src="url">
        </div>

        <div class="product-info">
            <div class="title-productname">
                <span>{{productName}}</span>
            </div>

            <div style="text-align: right; color: #606266">
                <span style="font-size: 12px">×</span>
                <span style="font-size: 14px">{{obj.BiggerThan}} {{obj.Unit}}</span>
            </div>

            <div style="text-align: right">
                <span class="price-span" style="font-size: 14px;">$ {{priceNum}}</span>

            </div>
        </div>
    </div>
</template>

<script setup>

    import {computed, onBeforeMount, ref, toRef} from "vue";
    import myUtil from "@/util/util";
    import {useUserinfo} from "@/stores/userinfo";

    const props = defineProps(["obj"])

    const userInfoRef = toRef(useUserinfo())
    const url = ref(null)
    const priceNum =ref(0)

    const productName = computed(() => {
        let name = ""

        name = props.obj.ProductNameCN

        if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
            name = props.obj.ProductName
        }

        return name
    })

    onBeforeMount(() => {
        url.value = myUtil.generateEShopopeeProductImg(props.obj)
        // priceNum.value = myUtil.MathFix(props.obj.CCost, props.obj.BiggerThan, "*")
        priceNum.value = props.obj.CCost
    })

</script>

<style scoped>
    .product-box {
        display: flex;
        border-radius: 5px;
        background: #FAFAFA;
        margin-bottom: 10px;
        box-sizing: border-box;
        padding: 15px;
        text-align: left;
    }

    .product-box .product-img {
        width: 80px;
        height: 80px;
    }

    .product-box .product-img img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
        border: 1px #EBEEF5 solid;
    }

    .product-box .product-info {
        width: calc(100% - 80px);
        box-sizing: border-box;
        padding-left: 20px;
    }

    .product-box .title-productname {
        color: #606266;
        font-size: 14px;
        height: 3em;
    }

    .price-span{
        font-size: 14px;
        color: #e83f33;
    }
</style>